import React from 'react';
import { IconSVG } from '../../../components';
import { getAccentColor } from '../../../utils';

const accentColor = getAccentColor();

const Chat: React.FC = () => (
  <IconSVG width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7.33692 16.9053C7.29292 16.5773 7.26292 16.2453 7.26292 15.9053C7.26292 11.4873 11.0999 7.90527 15.8339 7.90527C17.9049 7.90527 19.8039 8.59127 21.2859 9.73227C21.3179 9.46027 21.3339 9.18427 21.3339 8.90527C21.3339 4.49427 17.2959 0.905273 12.3339 0.905273C7.37192 0.905273 3.33392 4.49427 3.33392 8.90527C3.33392 10.4203 3.80192 11.8643 4.69392 13.1303L0.919922 16.9053H7.33692Z"
      fill="black"
    />
    <path
      d="M21.795 18.2943C22.149 17.5433 22.333 16.7283 22.333 15.9053C22.333 12.5963 19.417 9.90527 15.833 9.90527C12.249 9.90527 9.33301 12.5963 9.33301 15.9053C9.33301 19.2143 12.249 21.9053 15.833 21.9053H24.201L21.795 18.2943Z"
      fill={accentColor}
    />
  </IconSVG>
);

export default Chat;



// WEBPACK FOOTER //
// ./packages/smart-home-support/pages/profile/tabs/HomeTab/icons/Chat.tsx